import { useHistory } from 'react-router-dom'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import { IconArrowLeft, IconHtArrowLeft } from '../../../assets/icons'
import bgHeaderTamove from '../../../assets/images/header_background.png'
import topBackgroundImg from '../../../assets/images/tracuu_background_top.png'
import './index.scss'

const HEADER_PARTNER_CONFIG = {
  TAMOVE: {
    iconBack: IconArrowLeft,
    headerClass: 'HeaderPartner--tamove',
    headerBackgroundValue: `url(${bgHeaderTamove})`,
    blendBackgroundValue: `url(${topBackgroundImg})`,
    blendHeight: 310,
    isAlwaysBlendHeaderWithBody: false
  },
  BIDV: {
    iconBack: IconHtArrowLeft,
    headerClass: 'HeaderPartner--bidv',
    headerBackgroundValue: 'linear-gradient(180deg, rgba(166, 205, 204, 1) 0%, #F0F5F5 40%)',
    blendBackgroundValue: 'linear-gradient(180deg, rgba(166, 205, 204, 1) 0%, #F0F5F5 40%)',
    blendHeight: 500,
    isAlwaysBlendHeaderWithBody: true
  }
}

export default function LayoutPartner({ 
  children, 
  headerTitle, 
  scrollableTitle,
  noHeader = false,
  noBackground = false,
  blendHeaderWithBody = false, 
  blendHeight,
  onGoBack 
}) {
  const history = useHistory()
  const { isEmbeddedView, isHeaderMiniAppExpand, appThemeName } = useAppParamsContext()

  // Resolve config based on theme, fallback to TAMOVE
  const themeConfig = HEADER_PARTNER_CONFIG[appThemeName] || HEADER_PARTNER_CONFIG.TAMOVE
  
  const { 
    iconBack: IconBack, 
    headerClass, 
    headerBackgroundValue,
    blendBackgroundValue,
    blendHeight: defaultBlendHeight,
    isAlwaysBlendHeaderWithBody 
  } = themeConfig

  // KiemDinhOto's old HeaderPartner hid itself if isEmbeddedView was true
  const hideHeader = isEmbeddedView || noHeader

  // Quyết định xem có kéo background từ header xuống body hay không
  // Nếu config cứng là isAlwaysBlendHeaderWithBody = true, luôn luôn kéo
  // Nếu không, phụ thuộc vào prop blendHeaderWithBody truyền từ từng trang
  const finalBlendBg = isAlwaysBlendHeaderWithBody || blendHeaderWithBody
  const finalBlendHeight = blendHeight || defaultBlendHeight || 500

  return (
    <div id="LayoutPartner" className={finalBlendBg ? 'LayoutPartner--blend-header' : ''}>
      {/* Background body (kéo dài xuống content) - chỉ hiển thị nếu finalBlendBg = true */}
      {finalBlendBg && (
        <div 
          className="LayoutPartner_blend_bg" 
          style={{ 
            backgroundImage: blendBackgroundValue,
            height: finalBlendHeight
          }} 
        />
      )}

      {!hideHeader && (
        // Nếu không finalBlendBg, ta thêm class để giới hạn nội dung
        <div className={`HeaderPartner ${headerClass} ${isHeaderMiniAppExpand ? 'HeaderPartner_expand' : ''} ${!finalBlendBg ? 'HeaderPartner--contained-bg' : ''} ${noBackground ? 'HeaderPartner--no-background' : ''}`}>
          <div className="HeaderPartner_fixed">
            {!noBackground && headerBackgroundValue && (
              <div className="HeaderPartner_fixed_bg_wrapper">
                <div
                  className="HeaderPartner_fixed_bg"
                  style={{ backgroundImage: headerBackgroundValue }}
                />
              </div>
            )}

            <div className="HeaderPartner_fixed_content">
              <div className="HeaderPartner_fixed_content_left" onClick={() => {
                if (onGoBack) {
                  onGoBack()
                } else {
                  history.goBack()
                }
              }}>
                {IconBack && <IconBack className={`${noBackground ? 'iconDark' : ''}`} />}
              </div>
              <div className="HeaderPartner_fixed_content_title">
                {headerTitle}
              </div>
              <div className="HeaderPartner_fixed_content_right"></div>
            </div>
          </div>
          <div className="HeaderPartner_padding"></div>
        </div>
      )}

      {/* Text cuộn theo body (Large Title) */}
      {scrollableTitle && !hideHeader && (
        <div className={`LayoutPartner_scrollable_title ${headerClass}`}>
          {scrollableTitle}
        </div>
      )}
      
      <div className="LayoutPartner_children">{children}</div>
    </div>
  )
}
